import { S3_BASE_URL } from "@/utils/s3";
import { parsePokeNameForSprite } from "utils/pokemon/name-utils";

/**
 * Warms the browser cache for a pokemon's idle sprite (XML + sheet) so the
 * card in the pack reveal shows the sprite instantly instead of popping in
 * blank. Resolves once both are fetched (or on error, so we never hang).
 */
export const preloadPokemonSprite = (
  baseName: string,
  isShiny = false,
): Promise<void> => {
  let name = parsePokeNameForSprite(baseName);
  if (isShiny) name += "__shiny";

  const xml = fetch(`${S3_BASE_URL}/pokemons/${name}/AnimData.xml`).then(
    (r) => r.text(),
    () => undefined,
  );

  const image = new Promise<void>((resolve) => {
    const img = new Image();
    img.onload = () => resolve();
    img.onerror = () => resolve();
    img.src = `${S3_BASE_URL}/pokemons/${name}/Idle-Anim.png`;
  });

  return Promise.all([xml, image]).then(() => undefined);
};
